import { H3 } from './subTitle.styled';

export const SubTitle = ({ text }) => {
  return <H3>{text}</H3>;
};
